import React from 'react'
import * as R from 'ramda'

interface ScrollOptions {
  behavior?: ScrollBehavior
  block?: ScrollLogicalPosition
}

export const useTabScrollIntoView = (
  activeTab: unknown,
  { behavior = 'smooth', block = 'end' }: ScrollOptions = {},
) => {
  const ref = React.useRef<HTMLElement>(null)

  React.useLayoutEffect(() => {
    if (R.isNil(activeTab)) return

    const timeout = window.setTimeout(() => {
      ref?.current?.scrollIntoView({ behavior, block })
    }, 250)

    return () => {
      window.clearTimeout(timeout)
    }
  }, [activeTab, behavior, block, ref])

  return ref
}
